import { AbstractApi } from ".";

class MeetingsApi extends AbstractApi {
    baseUrl = '/api/meetings';

    store(payload) {
        return this.post(this.baseUrl, payload);
    }
}

export default new MeetingsApi();
